// Функция стилизованного селекта
if ($('.select').length > 0) {
    $('.select').each(function () {
        var $select = $(this);
        var class_name = $select.data('class-wrapper');

        if (!$select.data('class-wrapper')) {
            class_name = 'select';
        } else {
            class_name = $select.data('class-wrapper');
        }


        var options = [];
        var placeholder_val;

        for (var i = 0; i < $(this).find('select option').length; i++) {
            var $option = $(this).find('select option').eq(i);

            if ($option.val() === ('option-placeholder')) {
                placeholder_val = $option.val();
            }

            var val = $option.val();
            var name = $option.text().charAt(0).toLowerCase();
            options[i] = {val: val, name: name};
        }

        function placeholderCheck($button, val) {
            if (val === placeholder_val) {
                $button.addClass(class_name + '__button--placeholder');
            } else {
                $button.removeClass(class_name + '__button--placeholder');
            }
        }

        function search(source, name) {
            var results;
            name = name.toString().toLowerCase();
            results = $.map(source, function (entry) {
                var match = entry.name.toLowerCase().indexOf(name) !== -1;
                return match ? entry : null;
            });
            return results;
        }

        $select.find('select').selectmenu({
            classes: {
                "ui-selectmenu-button-open": class_name + "__button " + class_name + "__button--open",
                "ui-selectmenu-button-closed": class_name + "__button",
                "ui-selectmenu-icon": class_name + "__icon",
                "ui-selectmenu-text": class_name + "__text",
                "ui-selectmenu-menu": class_name + "__menu"
            },
            create: function (event, ui) {
                inputListening($(event.target));
                placeholderCheck($(event.target).selectmenu("widget"), $(event.target).val());
            },
            focus: function (event, ui) {

            },
            change: function (event, ui) {
                placeholderCheck($(event.target).selectmenu("widget"), $(event.target).val());
                $(event.target).trigger('change');
            }
        });

        function inputListening($select_widget) {

            var last_symbol = '';
            var last_try = 0;

            $select.keydown(function (eventObject) {
                var wasOpen = $($select_widget.selectmenu("menuWidget")).is(":visible");

                if (eventObject.which === 40 && !wasOpen) {
                    $select_widget.selectmenu("open");
                }

                if (eventObject.originalEvent.key.length === 1) {
                    var symbol = eventObject.originalEvent.key;
                    var count_result = search(options, symbol).length;

                    if (count_result > 0) {
                        if (symbol === last_symbol) {
                            last_try = last_try + 1;

                            if (last_try === count_result) {
                                last_try = 0;
                            }

                            $select.find('select').val(search(options, symbol)[last_try].val);
                            $select_widget.selectmenu("refresh");
                        } else {
                            last_symbol = symbol;
                            last_try = 0;
                            $select.find('select').val(search(options, symbol)[last_try].val);
                            $select_widget.selectmenu("refresh");
                        }

                    }


                }
            });
        }


    });
}
